import { TerminListAdminFilter } from '../../../../../model/TerminListAdminFilter';
import { defaultPerPageValue } from '../../../../../constants/PaginationPerPageConstants';

export default (
  page: number,
  perPage: number,
  sort: Array<string>,
  filter: TerminListAdminFilter,
): URLSearchParams => {
  const updatedSearchParams = new URLSearchParams();

  if (filter.hladanyTermin) {
    updatedSearchParams.set('hladanyTermin', filter.hladanyTermin);
  }

  if (filter.publikovany !== undefined) {
    updatedSearchParams.set('publikovany', filter.publikovany ? 'true' : 'false');
  }

  if (filter.autorPoslednejZmeny) {
    updatedSearchParams.set('autorPoslednejZmenyUuid', filter.autorPoslednejZmeny.uuid);
  }

  if (page && page !== 1) {
    updatedSearchParams.set('page', page.toString());
  }

  if (perPage && perPage !== defaultPerPageValue) {
    updatedSearchParams.set('perPage', perPage.toString());
  }

  if (sort[0] && sort[1]) {
    if (sort[0] !== 'preferovanyTerminSort'
      || (sort[1] !== 'asc' && sort[1] !== 'desc')) {
      updatedSearchParams.delete('sort');
    } else {
      updatedSearchParams.set('sort', `${sort[0]},${sort[1]}`);
    }
  }
  return updatedSearchParams;
};
